module.exports = __webpack_public_path__ + "img/car_sendai05.5b3e13e3.jpg";